
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const InfoWindow = ({ onCloseClick, children, getRef }) => (
  <Fragment>
    {getRef &&
      <div className="InfoWindow" ref={ref => getRef(ref)}>
        <button type="button" className="InfoWindow_close" onClick={() => onCloseClick()}>
          <Icon className="InfoWindow_closeIcon" name="PlusExpand"></Icon>
        </button>

        <div className="InfoWindow_content">
          {children}
        </div>
      </div>
    }
  </Fragment>
);

InfoWindow.propTypes = {
  onCloseClick: PropTypes.func,
  getRef: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

InfoWindow.defaultProps = {
  getRef: () => {},
};

export default InfoWindow;
